import { UserRole } from '@uplift/types';
import { restClient } from '../client';

export type Conversation = {
  id: string;
  name: string;
  disabled: boolean;
  unreadMessagesCount: number;
  participantId: string;
  participantRole: UserRole;
};

export type Message = {
  id: string;
  senderId: string;
  receiverId: string;
  message: string;
  sentAt: string;
  seenAt: string | null;
  attachments: {
    id: string;
    name: string;
  }[];
};


export const getMessagingConversations = () => restClient.request<{
  data: Conversation[];
}>('/api/v1/messaging/conversation');


export const createMessagingConversations = (participantId: string) => restClient.request<{
  data: {
    conversationId: string;
  };
}>('/api/v1/messaging/conversation', {
  method: 'POST',
  data: {
    participant_id: participantId,
  }
});


export const getMessagesUpdates = () => restClient.request<{
  data: string | null;
}>('/api/v1/messaging/updates');


export const getMessages = (conversationId: string) => restClient.request<{
  data: Message[];
}>(`/api/v1/messaging/conversation/${conversationId}/message`);


export const sendMessage = (conversationId: string, message: string, attachmentIds?: string[]) => restClient.request<{
  data: Message[];
}>(`/api/v1/messaging/conversation/${conversationId}/message`, {
  method: 'POST',
  data: {
    message: message,
    attachment_ids: attachmentIds,
  },
});


export const markMessagesAsRead = (messageIds: string[]) => restClient.request<null>('/api/v1/messaging/mark-as-read', {
  method: 'PATCH',
  data: {
    message_ids: messageIds,
  },
});


export const getMessageAttachmentDownloadLink = (attachmentId: string) => restClient.request<{
  data: {
    downloadLink: string;
  };
}>(`/api/v1/messaging/attachments/${attachmentId}/download_link`, {
  method: 'POST',
});


export type ProviderMessagingReportItem = {
  userId: string;
  userName: string;
  oldestUnreadSentAt: string;
  newestUnreadSentAt: string;
  unreadMessagesCount: number;
};

export const adminMessagingGetUnreadReport = (userRole: UserRole) => restClient.request<{
  data: ProviderMessagingReportItem[];
}>(`/api/v1/admin/messaging/unread_report/by_role/${userRole}`);

export type UnreadConversationReportItem = {
  conversationId: string;
  senderId: string;
  userName: string;
  oldestUnreadSentAt: string;
  newestUnreadSentAt: string;
  unreadMessagesCount: number;
};

export const adminMessagingGetUnreadUserConversations = (userId: string) => restClient.request<{
  data: UnreadConversationReportItem[];
}>(`/api/v1/admin/messaging/unread_report/conversations/${userId}`);

export const adminMessagingGetConversationUnreadMessages = (conversationId: string, receiverId: string) => restClient.request<{
  data: Message[];
}>(`/api/v1/admin/messaging/unread_report/messages/${conversationId}/${receiverId}`);
